import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * ProtectedRoute'un içindeki tüm oturumlu rotaları (Layout + /abonelik
 * dahil) saran yaşam döngüsü guard'ı.  Amaç:  ``account_status ==
 * "deleted"`` olan kullanıcı ödeme ekranını dahi görmesin; yalnızca
 * ``/hesap-silinme-surecinde`` sayfasına yönlendirilsin.  Bu guard
 * authentication'a dokunmaz — user yüklenmişse yalnızca yönlendirme
 * yapar.
 */
export default function LifecycleGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  // AuthContext user===null iken kimliği doğrulama sürüyor demektir; bu
  // durumda alt ağacı doğrudan render et (ProtectedRoute zaten null'da
  // login'e atmıyor / auth durumu belirlenene kadar spinner gösterir).
  if (!user) return children;
  if (user.account_status === "deleted" && location.pathname !== "/hesap-silinme-surecinde") {
    return <Navigate to="/hesap-silinme-surecinde" replace state={{ from: location.pathname }} />;
  }
  return children;
}
